import { createAction, props } from '@ngrx/store';

export const setCustomer = createAction(
  '[Customer Component] Set Customer',
  props<{ customer: any }>()
);
